<template lang="pug">
content-page
	div(slot="nav")
		nav
			div
				.font-weight-bold.subtitle-1 {{$t('page.insurance:nav.heading')}}
				ul.list-unstyled
					li.nav-list-item
						nuxt-link(:to="localePath({name:'verzekering-reisverzekering'})") {{$t('page.insurance:nav.travel.insurance')}}
					li.nav-list-item
						nuxt-link(:to="localePath({name:'verzekering-profiel'})") {{$t('page.insurance:nav.claim')}}
					li.nav-list-item
						nuxt-link(:to="localePath({name:'verzekering-profiel'})") {{$t('page.insurance:nav.profile')}}
					li.nav-list-item
						nuxt-link(:to="localePath({name:'verzekering-zorgverzekering'})") {{$t('page.insurance:nav.health.insurance')}}
					li.nav-list-item
						nuxt-link(:to="localePath({name:'verzekering-slug', params: {slug: 'clausule-voor-seizoenswerk'}})") {{$t('page.insurance:nav.skiteacher.insurance')}}

	nuxt-child
</template>

<script>
import '@/plugins/insurance';

export default {
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
